export type ChangelogEntry = {
  commit: string;
  date: string;
  type: "feat" | "fix" | "perf" | "refactor" | "revert";
  scope: string | null;
  description: string;
  breaking: boolean;
};

export type ChangelogDocument = {
  schemaVersion: 1;
  generatedAt: string | null;
  repository: "web" | "api";
  historyScope: "checkout" | "staging";
  throughCommit: string | null;
  entries: ChangelogEntry[];
};

export async function getWebChangelog(): Promise<ChangelogDocument> {
  const response = await fetch("/changelog.json", { cache: "no-store" });
  if (!response.ok) {
    throw new Error(`Web changelog returned ${response.status}`);
  }
  const payload = (await response.json()) as Partial<ChangelogDocument>;
  if (payload.repository !== "web" || !Array.isArray(payload.entries)) {
    throw new Error("Web changelog is incomplete");
  }
  const throughCommit =
    typeof payload.throughCommit === "string" ? payload.throughCommit : null;
  return {
    schemaVersion: 1,
    generatedAt:
      typeof payload.generatedAt === "string" ? payload.generatedAt : null,
    repository: "web",
    historyScope:
      payload.historyScope === "staging" && throughCommit
        ? "staging"
        : "checkout",
    throughCommit,
    entries: payload.entries,
  };
}
